module.exports = __webpack_public_path__ + "img/main-log.1fdf7969.svg";